// extracted by mini-css-extract-plugin
export const phasesLengthContainer = "phases-length-module--phases-length-container--4CJkN";
export const withIcon = "phases-length-module--with-icon--Nf7D8";
export const phasesLengthIcon = "phases-length-module--phases-length-icon--3T5hT";
export const phasesLengthArrow = "phases-length-module--phases-length-arrow--3zHW0";
export const header = "phases-length-module--header--2EqqT";
export const phaseDescription = "phases-length-module--phase-description--2Ncrc";
export const phaseIcon = "phases-length-module--phase-icon--3w-5o";
export const days = "phases-length-module--days--29Y6R";
export const smallFont = "phases-length-module--small-font--1MmwR";